import React from "react";

interface ModalInfoCardProps {
  title: string;
  children: React.ReactNode;
}

const ModalInfoCard: React.FC<ModalInfoCardProps> = ({ title, children }) => {
  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-strokedark">
      <div className="border-b border-stroke p-5 px-7.5 dark:border-boxdark-2">
        <h4 className="text-sm font-semibold text-black dark:text-white">
          {title}
        </h4>
      </div>

      <div className="px-7.5 pt-6 pb-6 space-y-2">
        {children}
      </div>
    </div>
  );
};

export default ModalInfoCard;
